import CONST from './constant'
import Vue from 'vue'
import store from '@/store/index'

const moveElement = (array, targetPos, elements) => {
  Array.prototype.splice.apply(array, [targetPos, 0].concat(elements));
};

export default {
  fm: (val, precisionParam) => {
    if(val === null || val === undefined) {
      return '';
    }
    let decStr = ".",
      precision = precisionParam ? precisionParam : CONST.DECIMAL.DEFAULT_PRECISION;
    let str = Number(val).toFixed(precision).toString();
    if(-1 == str.indexOf(".")) {
      str += ".";
    }
    let arr = str.split(".");
    if(arr[0]) {
      let intStr = arr[0];
      intStr = intStr.replace("-", "");
      if(arr[1].length != precision) {
        if(arr[1].length > precision) {
          let tmpDec = Number("0." + arr[1]).toFixed(precision).toString();
          decStr += tmpDec.substring(tmpDec.indexOf(".") + 1);
        } else {
          decStr += arr[1];
          for(let i = 0, j = precision - arr[1].length; i < j; i++) {
            decStr += "0";
          }
        }
      } else {
        decStr += arr[1];
      }
      let intArr = intStr.split("").reverse();
      let n = Math.floor((intArr.length - 1) / 3);
      for (let i = 3, j = 0; j < n; i += 4, j++) {
        intArr.splice(i, 0, ",");
      }
      intArr = intArr.reverse();
      str = intArr.join("") + decStr;
      if (val < 0) {
        str = "-" + str;
      }
    }
    return str;
  },
  df: (val) => {
    if (val) {
      return Vue.prototype.moment(val).format("YYYY-MM-DD");
    }
    return "";
  },
  dhf: (val) => {
    if (val) {
      return Vue.prototype.moment(val).format("YYYY-MM-DD HH:mm:ss");
    }
    return "";
  },
  getNextYear: (date) => {
    let next = null;
    if(date) {
      next = new Date(date);
    } else {
      next = new Date();
    }
    next.setFullYear(next.getFullYear() + 1);
    next.setDate(next.getDate() - 1);
    return next;
  },
  getNextMonth: (date) => {
    let next = null;
    if(date) {
      next = new Date(date);
    } else {
      next = new Date();
    }
    next.setMonth(next.getMonth() + 1);
    return next;
  },
  getNextDate: (date) => {
    let next = null;
    if(date) {
      next = new Date(date);
    } else {
      next = new Date();
    }
    next.setDate(next.getDate() + 1);
    return next;
  },
  getDiffMonth(start, end) {
    let startDate = new Date(start),
        endDate = new Date(end),
        startYear = startDate.getFullYear(),
        endYear = endDate.getFullYear(),
        startMonth = startDate.getMonth(),
        endMonth = endDate.getMonth(),
        diffYear = startYear - endYear,
        diffMonth = startMonth - endMonth;
    return diffYear * 12 + diffMonth;
  },
  /**
   * 用于提供cascader组件的value转换map
   * e.g: dept_id = 5时 需要将值 5 转换 为按级次的 [1, 2, 5]
   * */
  generateMapOfIdsArray(rows, mapOfIdsArray) {
    let handlerRows = (row, idsArray) => {
      idsArray.push(row.id);
      mapOfIdsArray[row.id] = idsArray;
      if(row.children && row.children.length > 0) {
        row.children.forEach(row => {
          handlerRows(row, Vue.prototype._.cloneDeep(idsArray));
        })
      }
    };
    if(rows && rows.length > 0) {
      rows.forEach(row => {
        handlerRows(row, []);
      })
    }
  },
  /**
   * const moveElement = (array, targetPos, elements)
   * moveElementOfArray
   * moveElementOfArrayByIndex(array, targetPos, indexOfElement)
   * 数组中批量移动元素
   * array 需移动元素的数组
   * targetPos 移动到的位置（同数组一样位置从0开始）
   * elements 被移动的元素集合
   * indexOfElement 被移动的元素所在位置（同数组一样位置从0开始）
   * e.g: let array = [{
                        id: 1,
                        name: 'obj1'
                      }, {
                        id: 2,
                        name: 'obj2'
                      }, {
                        id: 3,
                        name: 'obj3'
                      }];
   * Util.moveElementOfArray(array, 0, [obj2, obj3]);
   * array:           [{
                        id: 2,
                        name: 'obj2'
                      }, {
                        id: 3,
                        name: 'obj3'
                      }, {
                        id: 1,
                        name: 'obj1'
                      }];
   * */
  moveElementOfArray: moveElement,
  moveElementOfArrayByIndex: (array, targetPos, indexOfElement) => {
    let element = array.splice(indexOfElement, 1)[0];
    moveElement(array, targetPos, [element]);
  },
  fillDictList: (idsArray, listArray) => {
    if(idsArray && listArray && idsArray.length === listArray.length) {
      let dictList = store.state.common.dictList;
      if(dictList && dictList.length > 0) {
        dictList.forEach(row => {
          let index = idsArray.findIndex(id => id === row.type);
          if(index !== -1) {
            listArray[index].push(row);
          }
        });
      }
    }
  },
  /*
  * 将obj中所有以_id或_num结尾的属性值转换为int或null
  * 将obj中所有以is_开始，并且值为空的属性删除
  * */
  changeIdToInt: (obj) => {
    for(let attr in obj) {
      if(attr.startsWith('is_')) {
        if(obj[attr] == '') {
          delete obj[attr];
        }
      }
      if(attr.endsWith('_id') || attr.endsWith('_num')) {
        if(obj[attr] == '') {
          obj[attr] = null;
        } else {
          obj[attr] = parseInt(obj[attr]);
        }
      }
    }
  },
  /*
  * 将obj中所有以_id结尾的属性值转换为String或null
  * */
  changeIdToString: (obj) => {
    for(let attr in obj) {
      if(attr.endsWith('_id')) {
        if(obj[attr]) {
          obj[attr] = String(obj[attr]);
        } else {
          obj[attr] = null;
        }
      }
    }
  },
  reset: (obj) => {
    delete obj.id;
    for(let attr in obj) {
      if(attr == 'token' || attr == 'page' || attr == 'rows' || attr == 'total' || attr == 'sort' || attr == 'order') {
        continue;
      } else if(attr.startsWith('selected')) {
        obj[attr] = null;
      } else if(attr.endsWith('amount') || attr.endsWith('Amount') || attr.endsWith('ratio') || attr.endsWith('Ratio')) {
        obj[attr] = 0;
      } else if(attr.endsWith('Array') || attr.endsWith('Arr') || attr.endsWith('List') || attr.endsWith('Range')) {
        obj[attr] = [];
      } else {
        obj[attr] = '';
      }
    }
  },
  exportExcel: (url, data) => {
    Vue.prototype.post(url, data).then(response => {
      if(response) {
        if(response.data['success']) {
          let url = response.data['msg'].toString();
          window.open(Vue.prototype.ax.baseURL + url, '_blank');
        }
      }
    });
  },
  costRowClassName({row, rowIndex}) {
    if (row.status === 2) {
      return 'audit-row';
    } else if (row.status === 3) {
      return 'balance-row';
    } else if(row.status === 4) {
      return 'error-row';
    }
    return '';
  },
  havePermissions(perms) {
    let loginInfo = store.state.user.loginInfo;
    if(perms && loginInfo && loginInfo.Pm) {
      if(typeof perms === 'string') {
        for(let i = 0, j = loginInfo.Pm.length; i < j; i++) {
          let permission = loginInfo.Pm[i];
          if(permission.key === perms) {
            return true;
          }
        }
      } else if(typeof perms === 'object') {
        let tmpPermsMap = [];
        perms.forEach(perm => {
          tmpPermsMap[perm] = false;
        });
        for(let i = 0, j = loginInfo.Pm.length; i < j; i++) {
          let permission = loginInfo.Pm[i];
          if(tmpPermsMap[permission.key] === false) {
            tmpPermsMap[permission.key] = true;
          }
        }
        for(let key in tmpPermsMap) {
          if(!tmpPermsMap[key]) {
            return false;
          }
        }
        return true;
      }
    }
  },

  // 获取指定容器滚动高度
  getScrollTop(ele) {  
    var scrollTop = ele.scrollTop
    return scrollTop
  },

  // spinner
  setSpinner(vueInstance, target) {
    if (vueInstance.loading) {
      let loading = vueInstance.Loading.Loading.service({
        text: '加载中，请稍后',
        background: 'rgba(255, 255, 255, 0.7)',
        target: target
      })

      let sI = setInterval(() => {
        if (!vueInstance.loading) {
          loading.close()
          clearInterval(sI)
        }
      }, 100)
    }
  },

  // tree 转 map
  transTreeToMap(tree, field) {
    if (!field) {
      field = 'children'
    }
    for (var i = 0; i < tree.length; i++) {
      CONST.DEPT_MAP[tree[i].id] = tree[i]
      if (tree[i][field]) {
        this.transTreeToMap(tree[i][field], field)
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/assets/js/util.js